import { render, staticRenderFns } from "./CadastrarInstituicao.vue?vue&type=template&id=65e8b1b4&"
import script from "./CadastrarInstituicao.vue?vue&type=script&lang=js&"
export * from "./CadastrarInstituicao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports